import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyBanner } from "@/components/StickyBanner";
import { SEO } from "@/components/SEO";
import { SpanishHero } from "@/components/SpanishHero";
import { SpanishWhyUs } from "@/components/SpanishWhyUs";
import { SpanishServices } from "@/components/SpanishServices";
import { SpanishTestimonials } from "@/components/SpanishTestimonials";
import { SpanishFAQ } from "@/components/SpanishFAQ";
import { SpanishFinalCTA } from "@/components/SpanishFinalCTA";
import { LocationContext } from "@/lib/locations";

import { Guarantee } from "@/components/Guarantee";
import { PricingCalculator } from "@/components/PricingCalculator";
import { FrequencyDiscounts } from "@/components/FrequencyDiscounts";

const LASpanishPage = () => {
  return (
    <LocationContext.Provider value={{ slug: "los-angeles", name: "Los Ángeles", type: "region", regionSlug: "los-angeles" }}>
      <SEO
        title="Limpieza del Hogar en Los Ángeles — Uplevel Cleaning"
        description="Servicio profesional de limpieza del hogar en Los Ángeles, Santa Mónica, Pasadena, Sherman Oaks y más. Precios planos, reserva en 60 segundos, garantía del 200%."
        keywords="limpieza del hogar los angeles, servicio de limpieza la, limpieza profunda los angeles, limpieza de mudanza la, empleada doméstica los angeles, limpieza de casas santa monica, limpieza pasadena, limpieza sherman oaks"
        url="https://uplevelcleaning.com/es/los-angeles"
        locationName="Los Ángeles"
        regionSlug="los-angeles"
        lang="es"
        includeLocalBusiness={true}
        includeFAQ={true}
        breadcrumbs={[
          { name: "Inicio", url: "/" },
          { name: "En Español", url: "/es" },
          { name: "Los Ángeles", url: "/es/los-angeles" }
        ]}
        reviews={[
          { author: "Sofía H.", rating: 5, reviewBody: "¡Fantástico! Mi apartamento en Santa Mónica nunca había estado tan limpio. El equipo fue muy amable y eficiente.", datePublished: "2026-03-12" },
          { author: "Diego V.", rating: 5, reviewBody: "Servicio impecable. Llegaron puntual, trabajaron duro y el resultado fue espectacular.", datePublished: "2026-02-25" },
          { author: "Isabella R.", rating: 5, reviewBody: "Encontrar un servicio de limpieza confiable en LA es difícil. ¡Uplevel Cleaning lo resolvió para nosotros!", datePublished: "2026-01-18" }
        ]}
      />
      <div className="flex min-h-screen flex-col" lang="es">
        <StickyBanner />
        <Navbar />
        <main className="flex-1">
          <SpanishHero cityName="Los Ángeles" regionSlug="los-angeles" />
          <SpanishWhyUs cityName="Los Ángeles" />
          {/* LA Sub-regions highlight */}
          <section className="py-16 bg-muted/30">
            <div className="container">
              <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">Áreas que Servimos en Los Ángeles</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                  { zone: "Westside", cities: "Santa Mónica, Venice, Brentwood, West LA, Culver City" },
                  { zone: "San Fernando Valley", cities: "Sherman Oaks, Encino, Studio City, Woodland Hills, Porter Ranch" },
                  { zone: "San Gabriel Valley", cities: "Pasadena, Arcadia, San Marino, Monrovia" },
                  { zone: "South Bay", cities: "Manhattan Beach, Redondo Beach, Torrance, El Segundo" },
                ].map((area, i) => (
                  <div key={i} className="bg-background rounded-2xl p-6 border shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 text-center">
                    <h3 className="font-bold text-primary mb-2">{area.zone}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{area.cities}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <SpanishServices />

          <FrequencyDiscounts />
          <PricingCalculator />
          <SpanishTestimonials region="la" />
          <Guarantee />
          <SpanishFAQ cityName="Los Ángeles" />
          <SpanishFinalCTA cityName="Los Ángeles" />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default LASpanishPage;
